import axios from "axios";
import { toast } from "sonner";
import { tenantHint } from "@/lib/tenant";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const t = tenantHint();
  if (t) config.headers["X-Tenant"] = t;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      const requestUrl = error?.config?.url || "";
      const isAuthCheck = requestUrl.includes("/auth/me");
      const path = window.location.pathname || "";
      const isPublicPage =
        /\/(vertrag-unterschreiben|termin-unterschreiben|meine-termine)\//.test(path) ||
        path === "/login" ||
        path === "/accept-invite";
      if (!isAuthCheck && !isPublicPage) {
        toast.error("Sitzung abgelaufen — bitte erneut einloggen");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
